import Seo from "../components/Seo";
import { SectionHead, CTABand, PlaceholderNote } from "../components/bits";
import { ABOUT } from "../content/pages";

export default function About() {
  return (
    <>
      <Seo path="/about" title="About" description="GPS Smart Labels is a product microsite from GoAndTrack — built to make choosing between Bluetooth and 4G smart labels honest and simple." />
      <section className="border-b border-border bg-brand-surface">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <h1 className="max-w-3xl text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">About this site</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-slate md:text-lg">{ABOUT.intro}</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
        <SectionHead kicker="How we work" title="Three rules this site follows" />
        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {ABOUT.principles.map((p) => (
            <div key={p.title} className="border-l-2 border-primary pl-6">
              <h2 className="text-lg font-semibold text-brand-navy">{p.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-brand-slate">{p.body}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 max-w-3xl">
          <PlaceholderNote text={ABOUT.note} />
        </div>
      </section>
      <CTABand />
    </>
  );
}
